import { combineReducers } from 'redux';
import snackbarState from './snackbarReducer';
import requestReducer from './subscriptionRequestReducer';
import subscriptionReducer from './subscriptionReducer';
import isLoadingReducer from './isLoadingReducer';
import assetReducer from './assetReducer';
import entity from './entityReducer';
import communitiesReducer from "./communitiesReducer";

const reducers = combineReducers({
  snackbarState,
  requestReducer,
  subscriptionReducer,
  isLoadingReducer,
  assetReducer,
  entity,
  communitiesReducer
});

export default reducers;



// WEBPACK FOOTER //
// ./src/modules/core/reducers/reducers.tsx